export default "__VITE_ASSET__BuwZ3$sD__"